import React from 'react';
import SignInForm from '@/components/auth/SignInForm';
import { useNavigate } from 'react-router-dom';

const SignInPage = () => {
  const navigate = useNavigate();

  const handleSignInSuccess = () => {
    navigate('/'); // Redirect to home page after successful sign in
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-adv-darkGray">
      <div className="w-full max-w-md p-8 bg-adv-black rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-white mb-6 text-center">Sign In</h1>
        <SignInForm onSuccess={handleSignInSuccess} />
      </div>
    </div>
  );
};

export default SignInPage; 